<template>
    <div class="index_bottom no-trans" v-loading="loading">
        <div class="bom_top_box">
            <div class="tops_box" v-if="vuex_bom_show">
                <div class="box_felx">
                    <div class="lefts">

                        <div class="logos">
                            <img src="../../assets/img/component/bottom/logos.png" alt="">
                        </div>
                        <div class="logo_text">
                            <div class="text1">资深法律顾问 为您答疑解惑</div>
                            <div class="text2_box">
                                <div class="text2_borders">梳理客户需求，提供专业服务</div>
                                <div class="text2_borders">行业经验丰富</div>
                                <div class="text2_borders">专业团队助力</div>
                            </div>
                        </div>
                    </div>
                    <div class="rights">
                        <div class="input_box">
                            <div class="input_lefts">
                                <!-- <div class="inputs1">
                                    <input type="text" v-model="form.mobile" placeholder="输入您的手机号">
                                </div>
                                <div class="inputs2">
                                  
                                    <el-cascader placeholder="请选择城市名称" v-model="area_ac" :options="area_list"  :props="props" @change="handleChange"></el-cascader>
                                </div> -->
                            </div>
                            <div class="input_rights">
                                <!-- <div class="inputs3">
                                    <div class="input_code">
                                        <input type="text" placeholder="输入验证码">
                                    </div>
                                    <div class="btns " @click="handle_code">{{ code_title }}</div>
                                </div> -->
                                <div class="inputs4">
                                    <div class="btns" @click="$router.push('/online')">立即咨询</div>
                                </div>
                            </div>
                        </div>
                        <div class="cleat_btn">
                            <div class="btn" @click="handle_vuex_bom_show">
                                <img src="../../assets/img/component/bottom/clear.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bom_bom_box">
            <div class="boms_box">
                <div class="bom_flex1">
                    <div class="lefts">
                        <div class="text1">友情链接</div>
                    </div>
                    <div class="rights">
                        <div class="text1" v-for="(item,index) in link_list" :key="index" @click="handle_url(item)">{{ item.title }}</div>
                    </div>
                </div>
                <div class="bom_flex2">
                    <div class="lefts">
                        <div class="tab_list" v-for="(item,index) in tab_list" :key="index">
                            <div class="item_title">{{ item.title }}</div>
                            <div class="item_list" v-for="(items,indexs) in item.list" @click="handle_path(items)" :key="indexs">{{ items.title }}</div>
                        </div>
                    </div>
                    <div class="rights">
                        <div class="img_flex">
                            <div class="img_box">
                                <div class="images">
                                    <img :src="vuex_setting.wbqrcode" alt="">
                                </div>
                                <div class="img_text">官方微博</div>
                            </div>
                            <div class="img_box">
                                <div class="images">
                                    <img :src="vuex_setting.qrcode_1" alt="">
                                </div>
                                <div class="img_text">微信公众号</div>
                            </div>
                            <div class="img_box">
                                <div class="images">
                                    <img :src="vuex_setting.xcxqrcode" alt="">
                                </div>
                                <div class="img_text">微信小程序</div>
                            </div>
                        </div>
                    </div>
                </div> 
            </div>
        </div>
        <div class="bom_bom_bq">
            <div class="texts" @click="handle_bq" v-html="vuex_setting.beian"></div>
        </div>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
export default {
    components: {

    },
    name: "index",
    data() {
        return {
            loading: false,
            area_list: [],
            area_ac:[],
            props:{
                label:'name',
                value:'id',
                children:'children',
            },
            // 中国裁判文书网     执行信息公开网     审判流程信息公开网     最高人民法院诉讼服务网     中国庭审公开网     人民法院公告网     中国法律法规数据库
            link_list:[
                {
                    title:'中国裁判文书网',
                    link:'',
                },
                {
                    title:'执行信息公开网',
                    link:'',
                },
                {
                    title:'审判流程信息公开网',
                    link:'',
                },
                {
                    title:'最高人民法院诉讼服务网',
                    link:'',
                },
                {
                    title:'中国庭审公开网',
                    link:'',
                },
                {
                    title:'人民法院公告网',
                    link:'',
                },

                 {
                    title:'中国法律法规数据库',
                    link:'',
                }
            ],
            tab_list:[
                {
                    title:'法律咨询',
                    list:[
                        {
                            title:'在线咨询',
                            path:'/online',
                        },
                        {
                            title:'预约律师',
                            path:'/lawyer_list',
                        },
                    ]
                },
                {
                    title:'裁判点评',
                    list:[
                        {
                            title:'裁判点评',
                            path:'/comments_list',
                        },
                        {
                            title:'案例库',
                            path:'/case_list',
                        },
                        {
                            title:'案源广场',
                            path:'/square_list',
                        },
                    ]
                },
                {
                    title:'企业法务',
                    list:[
                        {
                            title:'预约律师',
                            path:'/enterprise_list',
                        },
                        {
                            title:'在线委托',
                            path:'/enterprise_list',
                        }
                    ]
                },
                {
                    title:'个人法务',
                    list:[
                        {
                            title:'预约律师',
                            path:'/individual_list',
                        },
                        {
                            title:'在线委托',
                            path:'/individual_list',
                        }
                    ]
                },
                {
                    title:'法律讲堂',
                    list:[
                        {
                            title:'法律讲堂',
                            path:'/Classroom',
                        },
                        {
                            title:'法界热点',
                            path:'/hot_spot',
                        }
                    ]
                },
                {
                    title:'帮助中心',
                    list:[
                        {
                            title:'帮助中心1',
                            path:'',
                        },
                        {
                            title:'帮助中心2',
                            path:'',
                        },
                        {
                            title:'帮助中心3',
                            path:'',
                        },
                    ]
                }
            ],
            code_title:'获取验证码',
            code_time:60,
            timer:null,
            code_show:true,
            form:{
                
            }

        }
    },
    computed: {
        ...mapState(['vuex_setting','vuex_bom_show'])
    },
    watch: {

    },
    created() {
        this.get_area()
        this.get_link_list()
    },
    methods: {
        handleChange(e){
            console.log('选择',e)
        },
        get_area(){
            this.$api("getChinaArea", {
                parent_id:1,
				type:1,
			}, "get").then((res) => {
                this.loading = false
                console.log('地址',res)
                if (res.code == 1) {
                    this.area_list=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_url(item){
            window.open(item.url,'_blank')
        },
        handle_path(item){
            console.log('item',item)
			// document.querySelector('#app').scrollTop =0;
				
            this.$router.push({
                path:item.path
            })
        },
        get_link_list(){
            this.$api("getBanner", {
                position:11,
			}, "get").then((res) => {
                this.loading = false
                console.log('链接',res)
                if (res.code == 1) {
                     this.link_list=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_vuex_bom_show(){
            this.$store.commit('get_vuex_bom_show', false)
        },
        handle_code(){
            if(!this.form.mobile){
                alertErr('请输入手机号')
                return
            }
            if(!this.code_show){
                return
            }
            let reg = /^((11[0-9])|(12[0-9])|(13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/;
            if (!reg.test(this.form.mobile)) {
                alertErr('请输入正确的手机号')
                return 
            }
            this.$api("send", {
				mobile:this.form.mobile
			}, "get").then((res) => {
                this.loading = false
                console.log('注册',res)


                this.code_show=false
                this.code_title=this.code_time+'s'
                this.timer=setInterval(() => {
                    if(this.code_time==0){
                        this.code_time=60
                        this.code_show=true
                        this.code_title='重新发送'
                        clearInterval(this.timer)
                    }else{
                        this.code_time=this.code_time-1
                        this.code_title=this.code_time+'s'
                    }
                }, 1000);


                if (res.code == 1) {
                    alertSucc('发送成功')
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_bq(){
            window.open('https://beiancx.miit.gov.cn/','_blank')
        },

    },


}
</script>
<style scoped lang="less">
.index_bottom {
    width: 100%;

    .bom_top_box {
        // height: 210px;
        // padding-top: 65px;
        display: flex;
        flex-wrap: wrap;
        align-content: end;

        .tops_box {
            // width: 1920px;
            width: 100%;
            height: 143px;
            background: #35478F;
            border-radius: 0px 0px 0px 0px;

            .box_felx {
                width: 1440px;
                height: 100%;
                margin: auto;
                // background: red;
                display: flex;
                // align-items: center;
                justify-content: space-between;

                .lefts {
                    display: flex;
                    align-items: center;
                    .logos {
                        width: 210px;
                        // height: 210px;
                        height: 100%;
                        position: relative;

                        img {
                            position: absolute;
                            bottom: 0;
                            left: 0;
                            width: 210px;
                        }
                    }

                    .logo_text {
                        .text1 {
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 32px;
                            color: #FFFFFF;
                        }

                        .text2_box {
                            display: flex;
                            align-items: center;
                            padding-top: 20px;

                            .text2_borders {
                                padding: 7px 24px;

                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #FFFFFF;
                                margin-right: 10px;
                                border-radius: 23px 23px 23px 23px;
                                border: 1px dashed #FFFFFF;

                            }
                        }
                    }
                }

                .rights {
                    display: flex;
                    align-items: center;
                    .input_box{
                        display: flex;
                        align-items: center;
                        .input_lefts{
                            width: 200px;
                            margin-right: 10px;
                            .inputs1{
                                width: 200px;
                                height: 46px;
                                background: #FFFFFF;
                                border-radius: 8px 8px 8px 8px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                margin-bottom: 12px;
                                input{
                                    padding: 0 17px;
                                    height: 100%;
                                    
                                }
                                input::placeholder{
                                    color: #999999;

                                }  
                            }
                            .inputs2{
                                width: 200px;
                                height: 46px;
                                background: #FFFFFF;
                                border-radius: 8px 8px 8px 8px;
                                /deep/.el-select{
                                    width: 100%;
                                    height: 100%;
                                    border-radius: 8px 8px 8px 8px;

                                    .el-input{
                                        width: 100%;
                                        height: 100%;
                                        border-radius: 8px 8px 8px 8px;

                                        .el-input__inner{
                                            width: 100%;
                                            height: 100%;
                                            border-radius: 8px 8px 8px 8px;

                                        }
                                    }
                                }
                                /deep/.el-cascader{
                                    width: 100%;
                                    height: 100%;
                                    border-radius: 8px 8px 8px 8px;
                                    .el-input{
                                        width: 100%;
                                        height: 100%;
                                        border-radius: 8px 8px 8px 8px;

                                        .el-input__inner{
                                            width: 100%;
                                            height: 100%;
                                            border-radius: 8px 8px 8px 8px;

                                        }
                                    }
                                }
                            }
                        }
                        .input_rights{
                            width: 200px;
                            .inputs3{
                                width: 200px;
                                height: 46px;
                                background: #FFFFFF;
                                border-radius: 8px 8px 8px 8px;
                                display: flex;
                                align-items: center;
                                margin-bottom: 12px;
                                padding: 14px 16px;
                                .input_code{
                                    flex: 1;
                                    input{
                                        width: 100%;
                                        font-size: 14px;
                                        padding-right: 16px;
                                    }
                                }
                                .btns{
                                    width: 70px;
                                    flex-shrink: 0;
                                    cursor: pointer;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 14px;
                                    color: #377CFD;

                                }
                            }
                            .inputs4{
                                .btns{
                                    width: 200px;
                                    height: 46px;
                                    background: #FFAA00;
                                    border-radius: 8px 8px 8px 8px;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: bold;
                                    font-size: 18px;
                                    color: #FFFFFF;
                                    cursor: pointer;
                                    text-align: center;
                                    line-height: 46px;
                                }
                            }
                        }
                    }
                    .cleat_btn{
                        padding-left: 32px;
                        .btn{
                            cursor: pointer;
                            img{
                                width:32px ;
                                height: 32px;
                            }
                        }
                    }
                }

            }
        }
    }
    .bom_bom_box{
        // width: 1920px;
        width: 100%;
        height: 392px;
        background: #34383D;
        .boms_box{
            width: 1440px;
            height: 100px;
            // background-color: red;
            margin: auto;
            padding-top: 41px;
            .bom_flex1{
                display: flex;
                align-items: center;
                .lefts{
                    .text1{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 20px;
                        color: #FFFFFF;
                    }
                }
                .rights{
                    display: flex;
                    align-items: center;
                    padding-left: 30px;
                    .text1{
                        cursor: pointer;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 16px;
                        color: #FFFFFF;
                        margin-right: 30px;
                    }
                }
            }
            .bom_flex2{
                display: flex;
                align-items: center;
                padding-top: 57px;
                .lefts{
                    flex: 1;
                    display: flex;
                    align-items: top;
                    justify-content: space-between;
                    padding-right: 80px;
                    .tab_list{
                        .item_title{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 18px;
                            color: #FFFFFF;
                            margin-bottom: 25px;
                        }
                        .item_list{
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 16px;
                            color: #FFFFFF;
                            margin-bottom: 15px;
                        }
                    }
                }
                .rights{
                    width: 420px;
                    flex-shrink: 0;
                    .img_flex{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .img_box{
                            .images{
                                width: 120px;
                                height: 120px;
                                background: #FFFFFF;
                                border-radius: 0px 0px 0px 0px;
                            }
                            .img_text{
                                padding-top: 15px;
                                text-align: center;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 12px;
                                color: #FFFFFF;

                            }
                        }
                       
                    }
                }
            }
        }
    }
    .bom_bom_bq{
        background: #34383D;
        color: #FFFFFF;
        // cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        // padding: 20px;
        padding-bottom: 20px;
        .texts{
            cursor: pointer;
        }
    }

}
</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .index_bottom.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
    }
    .index_bottom.no-trans .bom_top_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .index_bottom.no-trans .bom_top_box .tops_box {
        min-height: 0;
        height: auto;
        border-radius: 0px 0px 0px 0px;
    }
    .index_bottom.no-trans .bom_top_box .tops_box .box_felx {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
        flex-wrap: wrap;
        gap: 8px;
    }
    .index_bottom.no-trans .bom_top_box .tops_box .box_felx .lefts {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .index_bottom.no-trans .bom_top_box .tops_box .box_felx .lefts .logos {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .index_bottom.no-trans .bom_top_box .tops_box .box_felx .lefts .logos img {
        max-width: 100%;
        min-width: 0;
        height: auto;
        width: 100%;
    }
    .index_bottom.no-trans .bom_top_box .tops_box .box_felx .lefts .logo_text .text1 {
        font-size: 24px;
    }
    .index_bottom.no-trans .bom_top_box .tops_box .box_felx .lefts .logo_text .text2_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .index_bottom.no-trans .bom_top_box .tops_box .box_felx .lefts .logo_text .text2_box .text2_borders {
        padding: 7px 16px;
        font-size: 14px;
        margin-right: 10px;
        border-radius: 8px 8px 8px 8px;
    }
    .index_bottom.no-trans .bom_top_box .tops_box .box_felx .rights {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .index_bottom.no-trans .bom_top_box .tops_box .box_felx .rights .input_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .index_bottom.no-trans .bom_top_box .tops_box .box_felx .rights .input_box .input_lefts {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin-right: 10px;
    }
    .index_bottom.no-trans .bom_top_box .tops_box .box_felx .rights .input_box .input_lefts .inputs1 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 46px;
        border-radius: 8px 8px 8px 8px;
        font-size: 14px;
        margin-bottom: 12px;
    }
    .index_bottom.no-trans .bom_top_box .tops_box .box_felx .rights .input_box .input_lefts .inputs1 input {
        padding: 0 16px;
    }
    .index_bottom.no-trans .bom_top_box .tops_box .box_felx .rights .input_box .input_lefts .inputs2 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 46px;
        border-radius: 8px 8px 8px 8px;
    }
    .index_bottom.no-trans .bom_top_box .tops_box .box_felx .rights .input_box .input_lefts .inputs2 /deep/ .el-select {
        border-radius: 8px 8px 8px 8px;
    }
    .index_bottom.no-trans .bom_top_box .tops_box .box_felx .rights .input_box .input_lefts .inputs2 /deep/ .el-select .el-input {
        border-radius: 8px 8px 8px 8px;
    }
    .index_bottom.no-trans .bom_top_box .tops_box .box_felx .rights .input_box .input_lefts .inputs2 /deep/ .el-select .el-input .el-input__inner {
        border-radius: 8px 8px 8px 8px;
    }
    .index_bottom.no-trans .bom_top_box .tops_box .box_felx .rights .input_box .input_lefts .inputs2 /deep/ .el-cascader {
        border-radius: 8px 8px 8px 8px;
    }
    .index_bottom.no-trans .bom_top_box .tops_box .box_felx .rights .input_box .input_lefts .inputs2 /deep/ .el-cascader .el-input {
        border-radius: 8px 8px 8px 8px;
    }
    .index_bottom.no-trans .bom_top_box .tops_box .box_felx .rights .input_box .input_lefts .inputs2 /deep/ .el-cascader .el-input .el-input__inner {
        border-radius: 8px 8px 8px 8px;
    }
    .index_bottom.no-trans .bom_top_box .tops_box .box_felx .rights .input_box .input_rights {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .index_bottom.no-trans .bom_top_box .tops_box .box_felx .rights .input_box .input_rights .inputs3 {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 8px 8px 8px 8px;
        flex-wrap: wrap;
        gap: 8px;
        margin-bottom: 12px;
        padding: 14px 16px;
        min-height: 44px;
    }
    .index_bottom.no-trans .bom_top_box .tops_box .box_felx .rights .input_box .input_rights .inputs3 .input_code input {
        font-size: 14px;
        padding-right: 16px;
    }
    .index_bottom.no-trans .bom_top_box .tops_box .box_felx .rights .input_box .input_rights .inputs3 .btns {
        width: 70px;
        font-size: 14px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .index_bottom.no-trans .bom_top_box .tops_box .box_felx .rights .input_box .input_rights .inputs4 .btns {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: auto;
        border-radius: 8px 8px 8px 8px;
        font-size: 18px;
        line-height: 1.6;
        min-height: 44px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .index_bottom.no-trans .bom_top_box .tops_box .box_felx .rights .cleat_btn {
        padding-left: 16px;
    }
    .index_bottom.no-trans .bom_top_box .tops_box .box_felx .rights .cleat_btn .btn img {
        width: 32px;
        height: 32px;
    }
    .index_bottom.no-trans .bom_bom_box {
        min-height: 0;
        height: auto;
    }
    .index_bottom.no-trans .bom_bom_box .boms_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        height: auto;
        margin: auto;
        padding-top: 16px;
    }
    .index_bottom.no-trans .bom_bom_box .boms_box .bom_flex1 {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .index_bottom.no-trans .bom_bom_box .boms_box .bom_flex1 .lefts .text1 {
        font-size: 20px;
    }
    .index_bottom.no-trans .bom_bom_box .boms_box .bom_flex1 .rights {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-left: 16px;
    }
    .index_bottom.no-trans .bom_bom_box .boms_box .bom_flex1 .rights .text1 {
        font-size: 16px;
        margin-right: 16px;
    }
    .index_bottom.no-trans .bom_bom_box .boms_box .bom_flex2 {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .index_bottom.no-trans .bom_bom_box .boms_box .bom_flex2 .lefts {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-right: 16px;
    }
    .index_bottom.no-trans .bom_bom_box .boms_box .bom_flex2 .lefts .tab_list .item_title {
        font-size: 18px;
        margin-bottom: 16px;
    }
    .index_bottom.no-trans .bom_bom_box .boms_box .bom_flex2 .lefts .tab_list .item_list {
        font-size: 16px;
        margin-bottom: 15px;
    }
    .index_bottom.no-trans .bom_bom_box .boms_box .bom_flex2 .rights {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .index_bottom.no-trans .bom_bom_box .boms_box .bom_flex2 .rights .img_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .index_bottom.no-trans .bom_bom_box .boms_box .bom_flex2 .rights .img_flex .img_box .images {
        width: 120px;
        min-height: 0;
        height: auto;
        border-radius: 0px 0px 0px 0px;
    }
    .index_bottom.no-trans .bom_bom_box .boms_box .bom_flex2 .rights .img_flex .img_box .img_text {
        padding-top: 15px;
        font-size: 14px;
    }
    .index_bottom.no-trans .bom_bom_bq {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-bottom: 16px;
    }
}
@media (max-width: 1024px) {
    .index_bottom.no-trans {
        .bom_top_box .tops_box { height: auto; }
        .bom_top_box .tops_box .box_felx { padding: 24px 20px; gap: 20px; }
        .bom_top_box .tops_box .box_felx .lefts { width: 100%; }
        .bom_top_box .tops_box .box_felx .lefts .logos { display: none; }
        .bom_top_box .tops_box .box_felx .lefts .logo_text .text1 { font-size: 20px; }
        .bom_top_box .tops_box .box_felx .rights { width: 100%; }
        .bom_top_box .tops_box .box_felx .rights .input_box { width: 100%; }
        .bom_top_box .tops_box .box_felx .rights .input_box .input_lefts { display: none; }
        .bom_top_box .tops_box .box_felx .rights .input_box .input_rights { width: 100%; }
        .bom_top_box .tops_box .box_felx .rights .cleat_btn { margin-left: auto; }
        .bom_bom_box .boms_box { padding: 24px 20px; }
        .bom_bom_box .boms_box .bom_flex2 { gap: 24px; }
        .bom_bom_box .boms_box .bom_flex2 .lefts { width: 100%; display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 16px; }
        .bom_bom_box .boms_box .bom_flex2 .lefts .tab_list { margin: 0; width: 100%; }
        .bom_bom_box .boms_box .bom_flex2 .lefts .tab_list .item_list { min-height: 44px; line-height: 22px; padding: 11px 0; margin: 0; font-size: 13px; }
        .bom_bom_box .boms_box .bom_flex2 .rights .img_flex { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; }
        .bom_bom_box .boms_box .bom_flex2 .rights .img_flex .img_box { margin: 0; min-width: 0; }
        .bom_bom_box .boms_box .bom_flex2 .rights .img_flex .img_box .images { width: 100%; max-width: 120px; aspect-ratio: 1; margin: auto; }
        .bom_bom_box .boms_box .bom_flex2 .rights .img_flex .img_box .images img { width: 100%; height: 100%; object-fit: contain; }
        .bom_bom_bq { padding: 0 20px calc(20px + env(safe-area-inset-bottom, 0px)); font-size: 13px; }
        .bom_top_box .tops_box .box_felx { padding: 24px 16px 16px; gap: 16px; }
        .bom_top_box .tops_box .box_felx .lefts .logo_text .text1 { font-size: 18px; line-height: 28px; }
        .bom_top_box .tops_box .box_felx .lefts .logo_text .text2_box { gap: 6px; padding-top: 12px; }
        .bom_top_box .tops_box .box_felx .lefts .logo_text .text2_box .text2_borders { padding: 4px 8px; margin: 0; font-size: 13px; line-height: 22px; }
        .bom_top_box .tops_box .box_felx .rights .cleat_btn .btn { display: flex; align-items: center; justify-content: center; width: 44px; height: 44px; cursor: pointer; }
        .bom_top_box .tops_box .box_felx .rights .cleat_btn .btn img { width: 24px; height: 24px; }
        .bom_bom_box .boms_box { padding: 24px 16px; }
        .bom_bom_box .boms_box .bom_flex1 { display: block; }
        .bom_bom_box .boms_box .bom_flex1 .lefts .text1 { font-size: 16px; line-height: 24px; }
        .bom_bom_box .boms_box .bom_flex1 .rights { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 0 12px; padding: 8px 0 0; }
        .bom_bom_box .boms_box .bom_flex1 .rights .text1 { display: flex; align-items: center; min-height: 44px; margin: 0; font-size: 13px; line-height: 22px; }
        .bom_bom_box .boms_box .bom_flex2 .lefts { gap: 20px 12px; padding: 0; }
        .bom_bom_box .boms_box .bom_flex2 .lefts .tab_list .item_title { font-size: 15px; line-height: 24px; margin-bottom: 4px; }
        .bom_bom_box .boms_box .bom_flex2 .rights .img_flex .img_box .img_text { font-size: 13px; padding-top: 8px; }
    }
}
</style>
